export default __webpack_public_path__ + "static/media/5.844ce2d6.jpg";